module.exports = __webpack_public_path__ + "static/media/The Night King.9ad145bd.jpg";